import { getMockupsData } from '../../api';
import {createAsyncThunk} from "@reduxjs/toolkit";
import store from "../../store";
import {setNotifications} from "../slices/notifications";

export const getMockups = createAsyncThunk(
    'mockups/getMockups',
    async (queryParams: any, {rejectWithValue}) => {
        try {
            const mockups = await getMockupsData(queryParams);
            return mockups;
        } catch (error: any) {
            store.dispatch(setNotifications({text: error.message, type: 'error'}))
            return rejectWithValue(error.message)
        }
    }
);
// getMockupsStats is exported from mockupsStats thunk, not needed here
// export const getMockupsStats = createAsyncThunk(
//     'mockups/getMockupsStats',
//     async (queryParams: any, {rejectWithValue}) => {
//         try {
//             const mockupsStats = await getMockupsStatsData(queryParams);
//             return mockupsStats;
//         } catch (error: any) {
//             if(error.message === 'Unauthorized!'){
//                 store.dispatch(logOutUser())
//             }
//             store.dispatch(setNotifications({text: error.message, type: 'error'}))
//             return rejectWithValue(error.message)
//         }
//     }
// );

// export const getMockups3d = createAsyncThunk(
//     'analytics3d/getMockupsAnalytics3d',
//     async (queryParams: any, {rejectWithValue}) => {
//         try {
//             const mockups= await getMockupAnalytics3d(queryParams);
//             return mockups;
//         } catch (error: any) {
//             if(error.message === 'Unauthorized!'){
//                 store.dispatch(logOutUser())
//             }
//             store.dispatch(setNotifications({text: error.message, type: 'error'}))
//             return rejectWithValue(error.message)
//         }
//     }
// );
// export const addMockups3d = createAsyncThunk(
//     'analytics3d/addMockupsAnalytics3d',
//     async (queryParams: any, {rejectWithValue}) => {
//         try {
//             const mockups= await getMockupAnalytics3d(queryParams);
//             return mockups;
//         } catch (error: any) {
//             if(error.message === 'Unauthorized!'){
//                 store.dispatch(logOutUser())
//             }
//             store.dispatch(setNotifications({text: error.message, type: 'error'}))
//             return rejectWithValue(error.message)
//         }
//     }
// );

